import { FRONTEND_METRICS_API_URL } from '@/common/config'
import { getAuthHeader } from '@/services/authService'
import { logger } from '@/services/logger/loggers'

import { TranslationInterceptor } from '@sennder/shell-utilities'

if (!FRONTEND_METRICS_API_URL) {
  throw new Error('FRONTEND_METRICS_API_URL not defined')
}

export const translationInterceptor = new TranslationInterceptor(
  FRONTEND_METRICS_API_URL,
  getAuthHeader,
  logger
)
